import { render } from "./MatrixTable.vue?vue&type=template&id=365bb154&scoped=true"
import script from "./MatrixTable.vue?vue&type=script&lang=js"
export * from "./MatrixTable.vue?vue&type=script&lang=js"

import "./MatrixTable.vue?vue&type=style&index=0&id=365bb154&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365bb154"]])

export default __exports__